<mat-form-field
  class="form-field multi-select select-primary trim-padding"
  [floatLabel]="myFloatLabel && myFloatLabel !== 'never' ? myFloatLabel : 'auto'"
  [ngClass]="{ 'select-open': select.panelOpen, 'has-value': selectedChips?.length }"
>
  <span
    class="icon select-arrow"
    [inlineSVG]="(openIconPath ? openIconPath : '/icons/icon-arrow-') + (select.panelOpen ? 'up' : 'down') + '.svg'"
  ></span>

  <mat-select
    #select
    panelClass="select-options-primary"
    [formControl]="control"
    (selectionChange)="selected($event.value)"
    [placeholder]="placeholder | transloco"
    multiple
  >
    <mat-select-trigger>
      <div class="selected-options">
        @if (selectedChips?.length) {
          @if (!onlyCounterMode && !(countChipsMode && selectedChips?.length > hideSelectedThreshold)) {
            @for (option of selectedChips; track option; let i = $index) {
              <div class="selected-option">
                @if (translation) {
                  {{
                    (translationPrefix
                      ? translationPrefix + (optionObj && option?.text ? option.text : option)
                      : optionObj && option?.text
                        ? option.text
                        : option
                    ) | transloco
                  }}
                } @else {
                  {{ optionObj ? option.text : option }}
                }
                <span
                  class="icon-remove"
                  [inlineSVG]="'/icons/icon-close.svg'"
                  (click)="onChipRemoved($event, option)"
                ></span>
              </div>
            }
          } @else {
            <div class="selected-option">{{ selectedChips?.length + ' ' + ('global.selected' | transloco) }}</div>
          }
        }
      </div>
    </mat-select-trigger>

    @for (option of options; track option) {
      <mat-option [value]="option">
        @if (translation) {
          {{
            (translationPrefix
              ? translationPrefix + (optionObj ? option.text : option)
              : optionObj
                ? option.text
                : option
            ) | transloco
          }}
        } @else {
          {{ optionObj ? option.text : option }}
        }
      </mat-option>
    }
  </mat-select>

  @if (control.errors) {
    <div class="mat-error">
      @if (control.errors.required) {
        {{ 'form.error.required' | transloco }}
      }
    </div>
  }
</mat-form-field>

<ng-template #defaultIcon>
  <mat-icon matChipRemove>cancel</mat-icon>
</ng-template>
